import { useState } from "react";
import { useAgent } from "./useAgent.js";
import { Activity, Connect, MyAddress, Network, Onboarding, Requests } from "./screens.js";

type Tab = "address" | "connect" | "requests" | "network" | "activity";

const TABS: { id: Tab; label: string; icon: string }[] = [
  { id: "address", label: "Address", icon: "🪪" },
  { id: "connect", label: "Connect", icon: "🔗" },
  { id: "requests", label: "Requests", icon: "📨" },
  { id: "network", label: "Network", icon: "🌐" },
  { id: "activity", label: "Activity", icon: "✦" },
];

/** A shared address (alinq.ai/@handle) deep-links into Connect, prefilled. */
function prefillFromUrl(): string | undefined {
  const hay = window.location.pathname + window.location.hash + window.location.search;
  const m = /(@[a-z0-9._]+#[0-9A-F]{4})/i.exec(decodeURIComponent(hay));
  return m ? m[1] : undefined;
}

export default function AppShell() {
  const state = useAgent();
  const prefill = prefillFromUrl();
  const [tab, setTab] = useState<Tab>(prefill ? "connect" : "address");

  if (!state.handle) {
    return (
      <div className="app">
        <div className="content"><Onboarding /></div>
      </div>
    );
  }

  return (
    <div className="app">
      <div className="topbar">
        <a className="brand" href="/" aria-label="Alinq home">
          <img src="/brand/alinq-symbol.png" alt="" />
          <span className="wordmark"><span className="a">A</span><span className="rest">linq</span></span>
        </a>
        <span className="pill"><span className="dot" />{state.handle}</span>
      </div>
      <div className="content">
        {tab === "address" && <MyAddress state={state} />}
        {tab === "connect" && <Connect initialTarget={prefill} />}
        {tab === "requests" && <Requests state={state} />}
        {tab === "network" && <Network state={state} />}
        {tab === "activity" && <Activity state={state} />}
      </div>
      <nav className="tabbar">
        <div className="app-inner">
          {TABS.map((t) => (
            <button key={t.id} className={`tab ${tab === t.id ? "active" : ""}`} onClick={() => setTab(t.id)}>
              <span className="ic">{t.icon}</span>
              <span>{t.label}</span>
              {t.id === "requests" && state.requests.length > 0 && <span className="badge-count">{state.requests.length}</span>}
            </button>
          ))}
        </div>
      </nav>
    </div>
  );
}
